import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/article.svg";
var ArticleOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ArticleOutline_default as default
};
